export default "__VITE_ASSET__Bm0xOUwV__"